import { render, staticRenderFns } from "./ModalTutorialDevolucao.vue?vue&type=template&id=f0f299e8&scoped=true&"
import script from "./ModalTutorialDevolucao.vue?vue&type=script&lang=js&"
export * from "./ModalTutorialDevolucao.vue?vue&type=script&lang=js&"
import style0 from "./ModalTutorialDevolucao.vue?vue&type=style&index=0&id=f0f299e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f299e8",
  null
  
)

export default component.exports